'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Use `Tag` to display categories or statuses.
 *
 * @example
 * <Tag>Melk</Tag>
 */
const Tag = forwardRef(function Tag({ className, variant = 'default', ...rest }, ref) {
    return (jsx("span", { className: cl('ds-tag', className), ref: ref, "data-variant": variant, ...rest }));
});

export { Tag };
